<ul style="border: 2px solid #959697;max-height: 300px;overflow-y: scroll;">
  <li *ngFor="let item of DataList_User" style="list-style: none;" >
    <input  type="checkbox" (click)="OnChangeSelect_User(item)" [checked]="item.DeletingProccess" class="Lvl2" />  <span >{{item.name}} {{item.familly}}</span>

 </li>
</ul>

